export const TOGGLE_LIBRARY_PAGE = "TOGGLE_LIBRARY_PAGE";

export function toggleLibraryPage(isOpen, libraryItem) {
  return {
    type: TOGGLE_LIBRARY_PAGE,
    payload: { isOpen, libraryItem },
  };
}
